import React from 'react';

import {ImageWithFallback} from 'components/image-with-fallback';
import docxPng from 'shared/assets/docx.png';
import docxWebp from 'shared/assets/docx.webp';
import {ReactComponent as Excel} from 'shared/assets/excel.svg';
import {ReactComponent as File} from 'shared/assets/forms/file.svg';
import jsonPng from 'shared/assets/json.png';
import jsonWebp from 'shared/assets/json.webp';
import {ReactComponent as Xml} from 'shared/assets/xml.svg';

export interface IDocumentsUploadExtensionIconProps {
    fileName: string;
}

export const DocumentsUploadExtensionIcon = ({fileName}: IDocumentsUploadExtensionIconProps) => {
    const fileExtension = fileName.split('.').pop();

    if (fileExtension === 'doc' || fileExtension === 'docx') {
        return (
            <ImageWithFallback
                fallbackImageUrl={docxPng}
                imageUrl={docxWebp}
                style={{width: 20}}
                alt="doc"
            />
        );
    }
    if (fileExtension === 'json') {
        return (
            <ImageWithFallback
                fallbackImageUrl={jsonPng}
                imageUrl={jsonWebp}
                style={{width: 20}}
                alt="json"
            />
        );
    }
    if (fileExtension === 'xml') {
        return <Xml />;
    }
    if (fileExtension === 'xlsx') {
        return <Excel />;
    }
    return <File className="file-icon" />;
};
